import DefaultRenderer from './default';
import gsap from 'gsap';
import globe from '../../components/globe-new';

class home extends DefaultRenderer {
	onEnter() {
		super.onEnter();
		let mainScroll = this.mainController.getScroll();

		let video = document.getElementById('video'),
			play = document.getElementById('play'),
			videoContent = document.getElementById('video-content'),
			videoWrapper = document.getElementById('video-wrapper'),
			videoWrapperHeight = videoWrapper.offsetHeight;

		const videoTl = gsap.timeline({ paused: true });

		videoTl.to(
			[videoContent.querySelector('#play'), videoContent.querySelector('p'), videoContent.querySelector('h2')],
			{
				duration: 0.6,
				y: 20,
				autoAlpha: 0,
				stagger: 0.05,
			},
		);

		play.addEventListener('click', () => {
			videoTl.play();
			video.play();
			videoWrapper.classList.add('playing');
		});

		video.addEventListener(
			'ended',
			() => {
				videoTl.reverse();
				videoWrapper.classList.remove('playing');
			},
			false,
		);

		// Stop the video on scroll
		mainScroll.on('scroll', instance => {
			let windowProgress = (videoWrapperHeight - instance.scroll.y) / videoWrapperHeight;
			if (windowProgress > 0) {
				video.volume = windowProgress;
			} else if (windowProgress < 0) {
				if(videoWrapper.classList.contains('playing')) {
					video.pause();
					video.currentTime = 0;
					videoTl.reverse();
					videoWrapper.classList.remove('playing');
				}
			}
		});
		globe(mainScroll);
	}

	onLeave() {
		super.onLeave();
		let video = document.getElementById('video');
		gsap.to(video, {
			volume: 0,
		});
	}

	onEnterCompleted() {
		super.onEnterCompleted();
	}
}

export default home;



// WEBPACK FOOTER //
// ./scripts/highway/renderers/home.js